import { createContext } from 'react'

export const SidePanelContext = createContext<{
  isOpened: boolean
  isBlocked: boolean
  block: (isBlocking: boolean) => void
  close: () => void
}>({
  isOpened: false,
  isBlocked: false,
  block: () => null,
  close: () => null
})
